import { FileRenderer, fileType } from './FormFile'

class CustomFormFields {
  static $inject = ['formFields']
  constructor(formFields) {
    formFields.register(fileType, FileRenderer)
  }
  fileType
}

export default {
  __init__: ['fileUploadField'],
  fileUploadField: ['type', CustomFormFields],
}
